import React from "react";
import { HelpCircle } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

export const FaqAccordion = ({ title, faqs }) => (
  <>
    <h3 className="text-xl font-extrabold text-white mt-10 mb-3 flex items-center gap-2">
      <HelpCircle size={20} className="text-[#ffb224]" /> {title}
    </h3>
    <Accordion type="single" collapsible className="bg-[#073c1b] border border-[#1c5f35] rounded-2xl px-5">
      {faqs.map((faq, i) => (
        <AccordionItem key={faq.q} value={faq.q}>
          <AccordionTrigger className="text-left font-bold text-white text-sm hover:text-[#ffb224]">
            <span className="flex gap-2"><span className="text-[#ffb224]">Q.{i + 1}</span>{faq.q}</span>
          </AccordionTrigger>
          <AccordionContent className="text-emerald-50/70 text-sm leading-relaxed">{faq.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </>
);

export default FaqAccordion;
